/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Precomfort_Timeslot_Generation_Popup_TextInputs */



/**
* | output |
* | --- |
* | "Every night, the system generates the new schedule for the past day. It takes into account new presence detections and previous habits." |
*
* @param {Precomfort_Timeslot_Generation_Popup_TextInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const precomfort_timeslot_generation_popup_text = /** @type {((inputs?: Precomfort_Timeslot_Generation_Popup_TextInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Precomfort_Timeslot_Generation_Popup_TextInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Every night, the system generates the new schedule for the past day. It takes into account new presence detections and previous habits.")
	return /** @type {LocalizedString} */ ("Chaque nuit, le système génère le nouveau planning de la journée passée. Il prend en compte les nouvelles détections de présence et les précédentes habitudes.")
});